import useAuth from 'hooks/use-auth'
import {
  useAlfiClients,
  useInfraClients,
  useK8sClients
} from 'hooks/use-clients'
import { useGetTeamsPaged } from 'hooks/use-get-teams-paged'
import { useServices } from 'hooks/use-services'

export default function useLongRunningApiData(enabled = true): void {
  const {
    companyIsAlfiEnabled: isAlfiEnabled, // todo: EN-5114 deprecate
    hasReliabilityManagement
  } = useAuth()

  useServices(enabled && hasReliabilityManagement)
  useInfraClients({ enabled })
  useK8sClients({ enabled })
  useAlfiClients({ enabled: enabled && isAlfiEnabled })
  useGetTeamsPaged({ enabled })
}
